import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  useColorModeValue,
  HStack,
  UnorderedList,
  ListItem,
} from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PendingApproval = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const bgColor = useColorModeValue('white', 'gray.800');

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Container maxW="lg" py={12}>
      <Box
        bg={bgColor}
        p={8}
        rounded="lg"
        shadow="base"
      >
        <VStack spacing={6}>
          <Heading size="lg">Account Pending Approval</Heading>
          <Text textAlign="center" color="gray.600">
            Welcome {user?.name}! Your agent account is currently pending admin approval.
          </Text>
          <Box p={4} bg="yellow.50" rounded="md" w="full">
            <VStack spacing={3} align="start">
              <Text fontWeight="bold">What this means:</Text>
              <UnorderedList spacing={2} pl={4}>
                <ListItem>You can browse the website and view mutual funds</ListItem>
                <ListItem>Agent-specific features are temporarily restricted</ListItem>
                <ListItem>You'll receive an email when your account is approved</ListItem>
                <ListItem>After approval, you'll have full access to agent features</ListItem>
              </UnorderedList>
            </VStack>
          </Box>
          <HStack spacing={4}>
            <Button colorScheme="brand" variant="outline" onClick={() => navigate('/')}>
              Browse Site
            </Button>
            <Button colorScheme="brand" onClick={handleLogout}>
              Logout
            </Button>
          </HStack>
        </VStack>
      </Box>
    </Container>
  );
};

export default PendingApproval; 